/**
 * useCanManageNonWorkingDays — czy user widzi Ustawienia → „Dni wolne od pracy"
 * (kalendarz dni wolnych tenanta: święta „co roku" i daty jednorazowe).
 *
 * Warunek: `isSuperUser` LUB permission `crm_core.non_working_days.manage`. BEZ sprawdzania
 * modułu — `crm_core` jest pakietem bazowym, zawsze aktywnym dla każdego tenanta.
 *
 * Backend gate (jedno uprawnienie na wszystko — podgląd/dodawanie/edycja/usuwanie):
 * `apps/api/app/api/settings/non-working-days/` (`canTenantWide(ctx,
 * 'crm_core.non_working_days.manage')`).
 */
import { type TenantMeResponse, useTenantAuth } from '@/contexts/TenantAuthContext';

/** Czysta wersja (bez kontekstu) — dla miejsc, które mają `me` z opcjonalnego kontekstu. */
export function canManageNonWorkingDays(me: TenantMeResponse | null | undefined): boolean {
  const isSuperUser = me?.user.isSuperUser === true;
  const hasPermission = me?.permissions.includes('crm_core.non_working_days.manage') ?? false;
  return isSuperUser || hasPermission;
}

export function useCanManageNonWorkingDays(): boolean {
  const { me } = useTenantAuth();
  return canManageNonWorkingDays(me);
}
